import en from "../locales/en/common.json" with { type: "json" };
import tr from "../locales/tr/common.json" with { type: "json" };

export const supportedLocales = ["en", "tr"] as const;
export type SupportedLocale = (typeof supportedLocales)[number];
export const defaultLocale: SupportedLocale = "en";

export const resources = {
  en: { common: en },
  tr: { common: tr },
} as const;

export type CommonMessages = typeof en;

export function isSupportedLocale(value: string): value is SupportedLocale {
  return (supportedLocales as readonly string[]).includes(value);
}

/** Picks the best supported locale from an Accept-Language header or browser list. */
export function negotiateLocale(candidates: readonly string[]): SupportedLocale {
  for (const candidate of candidates) {
    const base = candidate.toLowerCase().split("-")[0] ?? "";
    if (isSupportedLocale(base)) {
      return base;
    }
  }
  return defaultLocale;
}
